<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    :disabled="disabledPull"
    @refresh="onRefresh"
  >
    <div class="page">
      <!-- 筛选选择 -->
      <div class="strategy-tabs">
        <div 
          class="strategy-tab" 
          :class="{ active: activeTag === 'all' }"
          @click="switchType('all')"
        >
          全站攻略
        </div>
        <div 
          class="strategy-tab" 
          :class="{ active: activeTag === 'collect' }"
          @click="switchType('collect')"
        >
          收藏
        </div>
      </div>

      <!-- 游戏信息卡片 -->
      <div v-show="!isCollectType" class="game-card mb_8">
        <div class="game-info">
          <img class="game-icon" :src="gameInfo.icon" alt="游戏图标" />
          <div class="game-details">
            <div class="game-title mb_12 van-ellipsis">{{ gameInfo.gameName }}</div>
            <p class="strategy-count">共<span style="color: #FE573F">{{ gameInfo.guideNum }}</span>篇攻略</p>
          </div>
        </div>
        <div class="view-button fs_14" @click="viewGame">查看游戏</div>
      </div>

      

      <!-- 标签筛选 -->
      <div v-show="!isCollectType" class="tag-filter">
        <van-tabs 
          v-model="activeTagId" 
          swipeable 
          animated
          background="#fff"
          color="#ff6347"
          title-inactive-color="#4a4a4a"
          title-active-color="#000"
          @change="handleTagChange"
        >
          <van-tab 
            v-for="(tag) in gameInfo.gameTagVoList" 
            :key="tag.tagId"
            :title="tag.tagName"
            :name="tag.tagId"
            title-style="font-size: 15px"
          ></van-tab>
        </van-tabs>
      </div>
      <!-- 排序方式 -->
      <div v-show="!isCollectType" class="sort-way fs_10" style="color: #5D82E3" @click="toggleSortType">
        <span>{{ sortTypeEnum[activeSortType].text }}</span>
        <van-icon name="sort" />
      </div>

      <!-- 攻略列表 -->
      <div class="strategy-list">
        <div 
          v-for="(item, index) in strategyList" 
          :key="index"
          class="strategy-list-item"
          @click="viewStrategyDetail(item)"
          :ref="index === strategyList.length - 1 ? 'lastItem' : null"
        >
          <div class="strategy-content">
            <div class="strategy-title">
              <p class="strategy-title-main color_black fs_15 van-multi-ellipsis--l2">{{ item.title }}</p>
            </div>
            <div class="strategy-meta mb_8">
              <div class="strategy-tags van-ellipsis">
                <span class="tag fs_10" v-for="(tag, tagIndex) in item.tagList" :key="tagIndex">#{{ tag }}</span>
              </div>
            </div>
            <div class="strategy-meta">
              <div class="strategy-actions">
                <div class="action-item text_nowrap">
                  <!-- <van-icon :name="item.praise ? 'like' : 'like-o'" :color="item.praise ? '#F53648' : '#999'" size="16" /> -->
                  <span>{{ wrapCountFn(item.praiseNum || 0) }}人点赞</span>
                </div>
                <div class="action-item text_nowrap">
                  <!-- <van-icon :name="item.collect ? 'star' : 'star-o'" :color="item.collect ? '#f7be65' : '#999'" size="16" /> -->
                  <span>{{ wrapCountFn(item.collectNum || 0) }}人收藏</span>
                </div>
              </div>
              <div class="strategy-date fs_10">{{ formatDate(item.updateTime || item.createTime) }}</div>
            </div>
            
          </div>
          <div class="strategy-cover" v-if="item.banner">
            <img :src="item.banner" alt="攻略封面" />
          </div>
        </div>
      </div>

      <!-- 加载更多 -->
      <div class="load-more" v-if="strategyList.length > 0">
        <van-loading v-if="isLoadingMore" size="24px" color="#999">加载中...</van-loading>
        <p v-else-if="noMoreData" class="no-more">没有更多数据了</p>
        <p v-else class="load-more-text" @click="loadMore">加载更多</p>
      </div>

      <!-- 空状态 -->
      <div class="empty-state" v-show="strategyList.length === 0 && !isLoading && !fetchLoading">
        <van-empty
          image="https://assets.hzwxbz2.cn/box/act_center/img/empty1.png"
          :description="isCollectType ? '收藏夹空空如也' : '攻略上架中，敬请期待～'"
          image-size="168"
        />
      </div>
    </div>
  </PullRefresh>
</template>

<script>
import { PullRefresh, Icon, Empty, Loading, Tab, Tabs } from "vant";
import { setPageTitle } from "@/bridge/AppJsBridge";
import LinkTo from '@/mixins/linkTo';
import EventTrack from '@/mixins/eventTrack';
import { getGameGuideHeadInfoApi, getTagGuideListApi, getCollectedGuideListApi } from '@/apis/btBoxActivity';
import Common from './common'

export default {
  mixins: [EventTrack, LinkTo, Common],
  components: {
    PullRefresh,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  data() {
    return {
      isLoading: false,
      isLoadingMore: false,
      fetchLoading: true,
      disabledPull: false,
      gameInfo: {
        gameId: '',
        gameName: '',
        gameTagVoList: [],
        guideGameId: '',
        guideNum: 0,
        icon: ''
      },
      activeTag: 'all', // 'all' 或 'collect'
      activeTagId: 0, // 当前选中的标签索引
      strategyList: [],
      lastGuideId: 0, // 替换 pageNum
      pageSize: 18, // 默认 18 条
      noMoreData: false,
      activeSortType: 1, // 当前选中的排序方式，默认为1
      lastSortTag: '', // 排序标识
      sortTypeEnum: {
        1: { text: '默认排序' },
        2: { text: '最近更新' },
        3: { text: '点赞最多' },
      },
      observer: null,
      firstActivate: false,
    }
  },
  computed: {
    gameId() {
      return this.$route.query.gameId
    },
    isCollectType () {
      return this.activeTag === 'collect'
    },
  },
  created() {
    this.init(true);
    this.getAppToken()
    this.$nextTick(() => {
      this.firstActivate = true
    })
  },
  activated () {
    if (this.firstActivate) {
      if (!this.isCollectType) {
        this.init()
      }
      this.getAppToken()
      // this.getActivityInfo()
    }
  },
  methods: {
    init(firstTime = false) {
      this.resetList(firstTime);
      return this.fetchGameInfo(firstTime).then(res => {
        this.onTrack("guide_page", {
          page_type: 2,
        })
        return res
      })
    },
    onRefresh() {
      this.init(false).finally(() => {
        setTimeout(() => {
          this.isLoading = false
        }, 200)
      })
    },
    getActivityInfo () {
      console.log('runrun', this.isCollectType)
      if (this.isCollectType) {
        this.fetchStrategyList();
      }
    },
    resetList(clearListFlag = true) {
      this.lastGuideId = 0;
      this.lastSortTag = ''; // 重置排序标识
      if (clearListFlag) {
        this.strategyList = [];
      }
      this.noMoreData = false;
    },
    fetchGameInfo(firstTime = true) {
      return getGameGuideHeadInfoApi({
        guideGameId: this.gameId
      }).then(res => {
        this.gameInfo = res.data || {};
        setPageTitle(this.gameInfo.gameName + '攻略');
        const list = this.gameInfo.gameTagVoList
        if (Array.isArray(list) && list.length) {
          if (firstTime && !this.isCollectType) {
            this.activeTagId = list[0].tagId
          }
          this.fetchStrategyList();
        }
      }).catch(err => {
        console.error('获取游戏信息失败:', err);
      })
    },
    fetchStrategyList() {
      this.fetchLoading = true
      const params = {
        guideGameId: this.gameId,
        lastGuideId: this.lastGuideId,
        tagId: this.activeTagId,
        sortType: this.activeSortType,
        sortTag: this.lastSortTag, // 添加排序标识
        pageSize: this.pageSize,
      };

      const colParams = {
        guideGameId: this.gameId,
        lastGuideId: this.lastGuideId,
      }

      this.isLoadingMore = this.lastGuideId > 0;

      const api = this.isCollectType ? getCollectedGuideListApi : getTagGuideListApi
      
      return api(this.isCollectType ? colParams : params).then(res => {
        const list = res.data || [];
        
        if (this.lastGuideId === 0) {
          this.strategyList = list;
        } else {
          this.strategyList = [...this.strategyList, ...list];
        }
        
        // 更新 lastGuideId 为最后一条数据的 ID
        if (list.length > 0) {
          const lastItem = list[list.length - 1];
          this.lastGuideId = lastItem.guideId;
          this.updateSortType()
        }
        
        this.noMoreData = list.length < this.pageSize;
        this.isLoadingMore = false;
        
        // 数据加载完成后设置观察者
        this.$nextTick(() => {
          this.observeLastItem();
        });
      }).catch(err => {
        console.error('获取攻略列表失败:', err);
        this.isLoadingMore = false;
      }).finally(() => {
        this.fetchLoading = false
      })
    },
    updateSortType () {
      const list = this.strategyList
      const lastItem = list[list.length - 1] || {}
      // 根据不同的排序方式，更新排序标识
      switch (this.activeSortType) {
        case 1: // 默认排序
          this.lastSortTag = lastItem.sort || '';
          break;
        case 2: // 最近更新
          this.lastSortTag = lastItem.updateTime || lastItem.createTime || '';
          break;
        case 3: // 点赞最多
          this.lastSortTag = String(lastItem.praiseNum || 0);
          break;
      }
    },
    loadMore() {
      if (this.noMoreData || this.isLoadingMore) return;
      this.fetchStrategyList();
    },
    switchType(tag) {
      if (this.activeTag === tag) return;
      this.activeTag = tag;
      this.onTrack("guide_collect_tab_button", {
        page_type: 2,
        tab_type: tag === 'collect' ? 2 : 1,
      })
      this.resetList();
      this.fetchStrategyList();
    },
    viewGame() {
      this.onTrack("guide_view_game_button", {
        page_type: 2,
      })
      this.goGameDetail()
    },
    viewStrategyDetail(item) {
      const { guideId, title } = item
      const extraParams = {
        tag_id: this.activeTagId,
        tag_name: (this.gameInfo.gameTagVoList.find(v => v.tagId === this.activeTagId) || {}).tagName,
      }
      this.onTrack("guide_click", {
        tab_type: this.isCollectType ? 2 : 1,
        page_type: 2,
        ...(this.isCollectType ? {} : extraParams),
        guide_id: guideId,
        guide_name: title,
      })
      this.$router.push({
        name: 'box.gameStrategyDetail',
        query: { guideId }
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      return dateStr.split(' ')[0] + ' 更新';
    },
    
    handleTagChange(id) {
      this.onTrack("guide_tag_tab_button", {
        page_type: 2,
        tab_type: 1,
        tag_id: id,
        tag_name: (this.gameInfo.gameTagVoList.find(v => v.tagId === id) || {}).tagName,
      })
      this.activeTagId = id
      this.resetList();
      this.fetchStrategyList();
    },
    
    // 切换排序方式
    toggleSortType() {
      // 按顺序循环切换：1 -> 2 -> 3 -> 1
      this.activeSortType = this.activeSortType % 3 + 1;
      this.updateSortType()
      this.resetList();
      this.fetchStrategyList();
    },
    
    // 添加观察者方法
    observeLastItem() {
      // 如果已经没有更多数据或正在加载中，不需要观察
      if (this.noMoreData || this.isLoadingMore) return;
      
      // 确保之前的observer被销毁
      if (this.observer) {
        this.observer.disconnect();
      }
      
      // 创建新的观察者
      this.$nextTick(() => {
        const lastItem = this.$refs.lastItem;
        if (!lastItem) return;
        const theRef = Array.isArray(lastItem) ? lastItem[0] : lastItem
        
        this.observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            // 当最后一个元素进入视口时，加载更多
            this.loadMore();
          }
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0.1
        });

        this.observer.observe(theRef);
      });
    },
  },
  // 在组件销毁时清理观察者
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
.page {
  padding: 8px;
  background-color: #fff;
  min-height: 100vh;
  color: var(--color-black-1);
}

.strategy-tabs {
  display: flex;
  margin: 0 auto 4px;
  position: relative;
  background-color: #CFD9FC;
  border-radius: 24px;
  padding: 4px;
  width: fit-content;
  justify-content: center;

  .tabs-container {
    display: flex;
    position: relative;
    border-radius: 20px;
    overflow: hidden;
  }
  
  .strategy-tab {
    text-align: center;
    padding: 10px 24px;
    font-size: 15px;
    position: relative;
    color: #404873;
    transition: all 0.2s ease;
    z-index: 1;
    border-radius: 50px;
    white-space: nowrap;
    
    &.active {
      background-color: #fff;
      color: #000;
    }
  }
  
  .tab-indicator {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    z-index: 0;
  }
}

.tag-filter {
  margin-bottom: 6px;
  
  ::v-deep(.van-tab) {
    height: 40px;
  }
  
  ::v-deep(.van-tab) {
    padding: 0 16px;
    font-size: 14px;
  }
  
  ::v-deep(.van-tabs__line) {
    bottom: 8px;
  }
}

.sort-way {
  padding: 0 18px;
  text-align: right;
}

.strategy-list {
  .strategy-list-item {
    display: flex;
    padding: 12px 8px;
    // border-bottom: 1px solid #f5f5f5;
    
    .strategy-content {
      width: 0;
      flex: 1;
      margin-right: 8px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      
      .strategy-title {
        margin-bottom: 8px;
        
        .strategy-title-main {
          line-height: 1.3;
        }
      }
      
      .strategy-meta {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .strategy-tags {
          // flex-wrap: wrap;
          color: #f09900;
          .tag {
            margin-right: 6px;
          }
        }
        
        .strategy-date {
          color: #999;
          white-space: nowrap;
        }
      }
      
      .strategy-actions {
        display: flex;
        
        .action-item {
          display: flex;
          align-items: center;
          margin-right: 8px;
          
          i {
            margin-right: 4px;
          }
          
          span {
            font-size: 10px;
            color: #999;
          }
        }
      }
    }
    
    .strategy-cover {
      width: 126px;
      height: 70px;
      border-radius: 8px;
      overflow: hidden;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .strategy-list-item + .strategy-list-item {
    margin-top: 8px;
  }
}

.load-more {
  text-align: center;
  padding: 16px 0;
  
  .load-more-text {
    color: #666;
    font-size: 14px;
  }
  
  .no-more {
    color: #999;
    font-size: 12px;
  }
}

.empty-state {
  padding: 40px 0;
}
</style>